import type { ExpenseCategory } from '@eriko/shared-types';

export function CategoryBreakdownSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="flex flex-col animate-pulse" aria-hidden>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex items-baseline gap-3 py-3 border-t border-surface-200/70 last:border-b"
        >
          <span className="h-3 w-5 bg-surface-200/80 rounded-sm" />
          <span className="h-3 w-24 bg-surface-200/80 rounded-sm" />
          <span className="flex-1 border-b border-dotted border-surface-300 mb-1" />
          <span className="h-3 w-8 bg-surface-200/80 rounded-sm" />
          <span className="h-3 w-16 bg-surface-200/80 rounded-sm" />
        </div>
      ))}
    </div>
  );
}

export function CategoryBreakdown({ categories }: { categories: ExpenseCategory[] }) {
  if (categories.length === 0) {
    return (
      <div className="py-10 text-center">
        <p className="font-serif italic text-[15px] text-surface-500">
          No data for this period.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {categories.map((cat, i) => (
        <div
          key={cat.name}
          className="flex items-baseline gap-3 py-3 border-t border-surface-200/70 last:border-b"
        >
          <span className="font-mono text-[11px] text-surface-600 tabular-nums">
            {String(i + 1).padStart(2, '0')}
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[2px] text-surface-900">
            {cat.name}
          </span>
          <span className="flex-1 border-b border-dotted border-surface-400 mb-1" />
          <span className="font-mono text-[12px] text-surface-600 tabular-nums">
            {cat.percent}%
          </span>
          <span className="font-mono text-[13px] font-medium text-surface-900 tabular-nums">
            ${cat.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}
          </span>
        </div>
      ))}
    </div>
  );
}
